// Question textarea with a character counter and a submit button.
// Ctrl/Cmd+Enter submits.

import type { ManifestoLanguage } from '../../lib/useManifestoQuery';
import './QueryBox.css';

const MAX = 1000;

const PLACEHOLDER: Record<ManifestoLanguage, string> = {
  en: 'Ask a question about the PL and PN manifestos…',
  mt: 'Staqsi mistoqsija dwar il-manifesti tal-PL u l-PN…',
};
const SUBMIT_LABEL: Record<ManifestoLanguage, string> = {
  en: 'Ask',
  mt: 'Staqsi',
};
const HINT: Record<ManifestoLanguage, string> = {
  en: 'Ctrl/⌘ + Enter to submit',
  mt: 'Ctrl/⌘ + Enter biex tibgħat',
};

export default function QueryBox({
  value,
  onChange,
  onSubmit,
  language,
  loading,
}: {
  value: string;
  onChange: (v: string) => void;
  onSubmit: () => void;
  language: ManifestoLanguage;
  loading: boolean;
}) {
  const canSubmit = value.trim().length > 0 && value.length <= MAX && !loading;

  function onKeyDown(e: React.KeyboardEvent<HTMLTextAreaElement>) {
    if ((e.metaKey || e.ctrlKey) && e.key === 'Enter') {
      e.preventDefault();
      if (canSubmit) onSubmit();
    }
  }

  return (
    <div className="mf-query">
      <textarea
        className="mf-query__input"
        value={value}
        maxLength={MAX}
        rows={3}
        placeholder={PLACEHOLDER[language]}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        disabled={loading}
        aria-label={PLACEHOLDER[language]}
      />
      <div className="mf-query__bar">
        <span className="mf-query__count">
          {value.length}/{MAX}
        </span>
        <span className="mf-query__hint">{HINT[language]}</span>
        <button
          type="button"
          className="mf-query__submit"
          disabled={!canSubmit}
          onClick={() => onSubmit()}
        >
          {loading ? '…' : SUBMIT_LABEL[language]}
        </button>
      </div>
    </div>
  );
}
